import React, { useMemo } from 'react';
import BubbleCommon from '@op/components/BubbleCommon';
import ImportantIcon from '@op/assets/svg/hot-segment/important.svg';
import HotIcon from '@op/assets/svg/hot-segment/hot.svg';
import NewIcon from '@op/assets/svg/hot-segment/new.svg';
import RisingIcon from '@op/assets/svg/hot-segment/rising.svg';
import { IDiscussionItem } from '../types';
import './index.scss';

interface StatusBadgesProps {
    item: IDiscussionItem;
}

/** 状态标签 (Important / New / Hot / Rising) */
export default function StatusBadges({ item }: StatusBadgesProps) {


    const iconStateElement = useMemo(() => {

        const stateMap = {
            New: <BubbleCommon
                placement="top"
                showIcon={false}
                tipsMap={{
                    en: 'New: Topics appearing for the first time in the last 7 days.',
                    zh: 'New: 近7天首次出现的话题',
                }}
            >
                {/* <span className="dbo-discussion-status new">NEW</span> */}
                <img src={NewIcon} className="dbo-discussion-status-icon" />
            </BubbleCommon>,
            Rising: <BubbleCommon
                placement="top"
                showIcon={false}
                tipsMap={{
                    en: 'Rising: Average daily mentions > 50 over the past 7 days; growth rate > 50% over the past 7 days.',
                    zh: 'Rising: 近 7 天日均声量 > 50  ，近 7 天增长率 > 50%',
                }}
            >
                <img src={RisingIcon} className="dbo-discussion-status-icon" />
            </BubbleCommon>,
            Hot: <BubbleCommon
                placement="top"
                showIcon={false}
                tipsMap={{
                    en: 'Hot Events: Events ranked in the Top 3 for three or more consecutive days',
                    zh: '热门事件：连续三天及以上位于Top3内的事件',
                }}
            >
                <img src={HotIcon} className="dbo-discussion-status-icon" />
            </BubbleCommon>,
            Important: <BubbleCommon
                placement="top"
                showIcon={false}
                tipsMap={{
                    en: 'Important Events: Events with the Top 3 Importance values under current conditions',
                    zh: '重要性Top3事件：在当前条件下，重要性排名前三的事件',
                }}
            >
                <img src={ImportantIcon} className="dbo-discussion-status-icon" />
            </BubbleCommon>
        }

        const { event_stage } = item || {};


        return event_stage ? stateMap[event_stage] : null;
    }, [item])




    return iconStateElement;
}
